import { createElement as e } from "react";
import { connect } from "react-redux";
import { NavItem } from "react-bootstrap";
import { push } from "react-router-redux";

export default connect(
  (state, ownProps) => ({}),
  (dispatch, ownProps) => ({
    navigate: event => {
      event.preventDefault();
      dispatch(push(ownProps.href));
    },
  }),
)(({ navigate, href, ...props }) =>
  e(NavItem, { href, ...props, onClick: navigate }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/components/NavItemLink.js